import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { PaymentService } from "../services/payment/payment.service";
import { FormBuilder } from "@angular/forms";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ErrorHandlerService } from "../services/shared/error-handler.service";
import { UserServiceService } from "../services/user-service/user-service.service";
import { ProjectsService } from "../services/projects/projects.service";
import { ActivatedRoute } from "@angular/router";
import { interval } from "rxjs/observable/interval";
import swal from "sweetalert2";

@Component({
  selector: "app-project-bulk-calculator",
  templateUrl: "./project-bulk-calculator.component.html",
  styleUrls: ["./project-bulk-calculator.component.css"],
})
export class ProjectBulkCalculatorComponent implements OnInit {
  calculator = {
    down_payment: null,
    down_payment_type: "percentage",
    interval: null,
    contract_period_in_months: null,
  };
  special_payment = {
    special_payment_type: "percentage",
    special_payment_value: null,
    special_payment_count: null,
    special_payment_interval: "12",
    special_payment_date: null,
  };
  special_payments: any = [];
  project_id: any;

  units: any;
  panelOpenState: boolean = false;

  constructor(
    private http: HttpClient,
    private paymentService: PaymentService,
    private fb: FormBuilder,
    private slimLoadingBarService: SlimLoadingBarService,
    public errorHandlerService: ErrorHandlerService,
    private userService: UserServiceService,
    private projectService: ProjectsService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe((res) => {
      console.log(res);
      this.project_id = res.project_id;
    });
  }

  ngOnInit() {}

  addSpecialPayment() {
    const validForm = this.isCalculatorValid(this.special_payment);
    if (!validForm) {
      swal("Failure", "All fields are required", "error");
      return;
    }
    this.special_payments.push({ ...this.special_payment });
    this.special_payment = {
      special_payment_type: "percentage",
      special_payment_value: null,
      special_payment_count: null,
      special_payment_interval: "12",
      special_payment_date: null,
    };
    console.log(this.special_payments);
  }

  deleteSpecialPayment(index) {
    this.special_payments.splice(index, 1);
  }

  isCalculatorValid(calculator) {
    for (let key in calculator) {
      if (!calculator[key]) {
        return false;
      }
    }
    return true;
  }

  submitBulkCalculator() {
    const validForm = this.isCalculatorValid(this.calculator);
    if (!validForm) {
      swal("Failure", "All fields are required", "error");
      return;
    }
    const payload = {
      ...this.calculator,
      ...(this.special_payments.length > 0 && {
        special_payments: this.special_payments,
      }),
    };
    this.projectService
      .getProjectBulkCalculator(this.project_id, payload)
      .subscribe(
        (data) => {
          console.log(data);
          this.units = data;
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  confirmPrices() {
    const validForm = this.isCalculatorValid(this.calculator);
    if (!validForm) {
      swal("Failure", "All fields are required", "error");
      return;
    }
    const payload = {
      ...this.calculator,
      ...(this.special_payments.length > 0 && {
        special_payments: this.special_payments,
      }),
      is_confirmed: 1,
    };
    this.projectService
      .getProjectBulkCalculator(this.project_id, payload)
      .subscribe(
        (data) => {
          console.log(data);
          // this.units = data;
          swal(
            "Success",
            "confirmed and updated price successfully",
            "success"
          );
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/project-bulk-calculator/project-bulk-calculator.component.ts